import * as S from "./styles";

const Info = ({ number, labelComponent, onClick }) => {
  const upperFisrtLetter = (str) => {
    let firstWord = str.split(" ")[0];
    let restOfSentence = str.slice(firstWord.length).toLowerCase();
    return (
      firstWord.charAt(0).toUpperCase() + firstWord.slice(1) + restOfSentence
    );
  };

  return (
    <S.Info onClick={onClick} $clickable={!!onClick}>
      <S.NumberWrapper>
        <S.NumberText>{number}</S.NumberText>
      </S.NumberWrapper>
      <S.LabelWrapper>
        <S.LabelText>{upperFisrtLetter(labelComponent)}</S.LabelText>
      </S.LabelWrapper>
    </S.Info>
  );
};

export default Info;
